'use client'

import Script from 'next/script'

interface CustomScriptProps {
  script: string
}

export function CustomScript({ script }: CustomScriptProps) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(script, 'text/html')
  const scriptElement = doc.querySelector('script')

  // Plain JavaScript — existing behaviour
  if (!scriptElement) {
    return (
      <Script id="custom-script" strategy="afterInteractive">
        {script}
      </Script>
    )
  }

  const src = scriptElement.getAttribute('src')

  // External script
  if (src) {
    return (
      <Script
        id="custom-script"
        src={src.startsWith('//') ? `https:${src}` : src}
        strategy="afterInteractive"
        async={scriptElement.hasAttribute('async')}
        defer={scriptElement.hasAttribute('defer')}
      />
    )
  }

  // <script>inline code</script>
  return (
    <Script id="custom-script" strategy="afterInteractive">
      {scriptElement.textContent}
    </Script>
  )
}
